module.exports = __webpack_public_path__ + "img/logo-manas.de25acf3.png";